import styled from 'styled-components';
import { Combobox } from '@mantine/core';
import { textTinySemiBold } from '../../Typography';

export const StyledComboboxDropdownTargetContainer = styled.div`
  button {
    display: flex;
    height: 38px;
    padding: var(--space-100) var(--space-150);
    align-items: center;
    gap: var(--space-100);
    align-self: stretch;
    width: 100%;

    border-radius: var(--border-radius-button);
    border: 1px solid var(--black-500);
    background: var(--button-background);

    .loadingIndicator {
      animation: spin 1s linear infinite;

      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }

        100% {
          transform: rotate(360deg);
        }
      }
    }

    .openIndicator.open {
      transform: rotate(180deg);
    }

    .content {
      display: flex;
      align-items: center;
      gap: var(--space-100);
      flex: 1;

      &.warning > span {
        color: var(--text-warning);
      }

      span {
        color: var(--text-standard-primary);
        ${textTinySemiBold}
      }
      svg {
        color: var(--text-standard-secondary);
      }
    }
  }
`;

export const StyledDropdown = styled(Combobox.Dropdown)`
  background-color: var(--button-background);

  .mantine-ScrollArea-viewport {
    max-height: 200px;
  }
  .search {
    background-color: transparent;
  }

  .mantine-Combobox-option {
    ${textTinySemiBold}
    color: var(--text-standard-primary);
  }
`;
